import { z } from 'zod';
import { shiftWithMissionAndAnalyticsAndUserParticipationSchema } from './shiftCommonSchema';
const getShiftsByMissionIdParamsSchema = z.object({
    missionId: z.string().uuid(),
    isVolunteerView: z.boolean().optional(),
});
const getShiftsByMissionIdResponseSchema = shiftWithMissionAndAnalyticsAndUserParticipationSchema.merge(z.object({
    permissions: z.string().array().optional(), // TODO: Change to required - CRMS-3034
}));
const partialGetShiftsByMissionIdResponseSchema = getShiftsByMissionIdResponseSchema.omit({
    columns: true,
});
export const getShiftsByMissionIdFunctionDef = {
    name: 'getShiftsByMissionId',
    requestSchema: getShiftsByMissionIdParamsSchema,
    responseSchema: getShiftsByMissionIdResponseSchema.array(),
};
